import {
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Select, Option } from "@mui/base";
import { useState } from "react";

export default function DropdownSelect({
  children,
  value,
  onChange,
  openOverride = null,
  width = "w-48",
  inputClassNameOverrides = null,
  popupClassNameOverrides = null,
  placeholder = null,
  disabled,
  compact = false,
  dataTestId,
}) {
  const [isOpen, setIsOpen] = useState(false);

  // Use openOverride if provided, otherwise use local state
  const isDropdownOpen =
    openOverride !== null ? openOverride : isOpen;
  const setDropdownOpen =
    openOverride !== null ? () => {} : setIsOpen;

  return (
    <div className="relative flex flex-1">
      <FontAwesomeIcon
        icon={isDropdownOpen ? faChevronUp : faChevronDown}
        className={`absolute ${
          compact ? "right-2 top-1.5" : "right-3 top-2.5"
        } text-gray-500 pointer-events-none`}
      />
      <Select
        value={value}
        onChange={onChange}
        listboxOpen={isDropdownOpen}
        onListboxOpenChange={setDropdownOpen}
        placeholder={placeholder}
        disabled={disabled}
        data-testid={dataTestId}
        className={`
            text-sm text-left ${
              compact ? "px-2 py-1" : "px-3 py-2"
            } rounded-lg outline-none ${width} truncate dark:text-gray-300 text-black dark:bg-gray-700 bg-gray-100
          ${inputClassNameOverrides}
          `}
        slotProps={{
          popup: {
            className: `
                z-50 max-h-[400px] overflow-auto rounded-xl shadow-md dark:bg-gray-700 dark:text-gray-300 bg-white border border-gray-50 dark:border-gray-800
                ${popupClassNameOverrides}
              `,
            style: { fontFamily: "Inter, sans-serif" },
          },
        }}
      >
        {children}
      </Select>
    </div>
  );
}

export const DropdownOption = ({
  children,
  value,
  classNameOverrides = null,
  compact = false,
  dataTestId,
}) => {
  return (
    <Option
      key={value}
      value={value}
      className={`
          ${
            compact ? "px-2 py-1" : "px-2 py-1.5"
          } truncate hover:bg-indigo-50 dark:hover:bg-gray-600/50 cursor-pointer dark:text-gray-300 text-black rounded-xl border border-white dark:border-gray-700 dark:hover:border-gray-600 hover:border-indigo-100
          ${classNameOverrides}
        `}
      data-testid={dataTestId}
    >
      {children}
    </Option>
  );
};
